import request from '../../requests/requests';
import { Api } from '../../config/api';
import { configs } from '../../config/config';

export function createGroup(data){
    return request({
        url:Api.group.create,
        method:configs.http.request.methodPost,
        data
    })
}

export function getGroupList(data){
    return request({
        url:Api.group.list,
        method:configs.http.request.methodGet,
        data
    })
}


export function getParentList(data){
    return request({
        url:Api.group.parent_list,
        method:configs.http.request.methodGet,
        data
    })
}

export function BindCustom(data){
    return request({
        url:Api.group.bind_custom,
        method:configs.http.request.methodPost,
        data
    })
}

export function BindRole(data){
    return request({
        url:Api.group.bind_role,
        method:configs.http.request.methodPost,
        data
    })
}

export function getGroup(data){
    return request({
        url:Api.group.info+data.id,
        method:configs.http.request.methodGet,
        data
    })
}

export function editGroup(data){
    return request({
        url:Api.group.edit+data.id,
        method:configs.http.request.methodPut,
        data
    })
}



export function getGroupListWithParent(data){
    return request({
        url:Api.group.all,
        method:configs.http.request.methodGet,
        data
    })
}

